import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SearchRequest } from './interfaces/search-request';
import { SearchResult } from './interfaces/search-result';
import { TableSearchRequest } from '../components/table/table.component';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable()
export class LendersSolicitorService {

  private url = environment.apiUrl + 'lenderssolicitors/';

  constructor(private http: HttpClient, public router: Router) {

  }

  getAll() {
    return this.http.get<any>(this.url);
  }

  lenderSolDetails(id: number) {
    return this.http.get<any>(this.url  + id);
  }

  addLenderSol(lenderSolDetails: any) {
    return this.http.put<any>(this.url , lenderSolDetails, httpOptions);
  }

  updateLenderSol(lenderSolDetails: any) {
    return this.http.post<any>(this.url, lenderSolDetails, httpOptions);
  }

  getSolicitorsPaged(request: TableSearchRequest) {
  let queryString = '';

  for (let i = 0; i < request.filterStrings.length; i++) {
    if (request.filterStrings[i] !== '' && request.filterStrings[i] !== null) {
      queryString += `&filterColumns=${request.filterColumns[i]}&filterStrings=${request.filterStrings[i]}`;
    }
  }

  return this.http.get<SearchResult>(
    `${this.url}paged?page=${request.page}&pageSize=${request.pageSize}&orderBy=${request.orderBy}&orderDirection=${request.orderDirection}${queryString}`
  );
}


}
